import { render, staticRenderFns } from "./limits.vue?vue&type=template&id=116ffe36&scoped=true"
import script from "./limits.vue?vue&type=script&lang=js"
export * from "./limits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116ffe36",
  null
  
)

export default component.exports